var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evening"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4200",
    x: 0.5,
    y: 0.5,
    width: 27.3625,
    height: 20.78,
    rx: 5.5,
    fill: "#F5F5F5",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M13.7249 7.10808V9.76008H16.8449V10.9691H13.7249V13.7381H17.2349V14.9471H12.2429V5.89908H17.2349V7.10808H13.7249Z",
    fill: "#233849"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/Evening.460912b10e0aba683f884ce358017ffc.svg";
export { ForwardRef as ReactComponent };